/*
 * @Author: wangjiaxin@leedarson.com
 * @Date: 2019-11-19 09:03:27
 * Copyright © Leedarson. All rights reserved.
 */

import { useEffect, useRef } from 'react';

const _events = ['touchstart'];

/**
 *
 * @param {*} current
 * @param {*} componentNode
 * @param {*} ignoreClass
 */
const findClosestNode = (current, ignoreClass) => {
  if (!ignoreClass) {
    return false;
  }
  if (typeof ignoreClass !== 'string') {
    return ignoreClass.contains(current);
  }

  const classNames = ignoreClass.split(' ');

  while (current.parentNode) {
    if (isNodeFound(current, classNames)) {
      return true;
    }

    current = current.parentNode;
  }
  return false;
};

/**
 *
 * @param {*} classNames
 * @param {*} handler
 */
export default function useOutsideClick(classNames, handler, needListener) {
  const handlerRef = useRef(handler);
  handlerRef.current = handler;
  const classNamesRef = useRef(classNames);
  classNamesRef.current = classNames;
  const needListenerRef = useRef(needListener);
  needListenerRef.current = needListener;

  useEffect(() => {
    let didCancel = false;

    const listener = (event) => {
      if (findClosestNode(event.target, classNamesRef.current)) {
        return;
      }

      if (!didCancel && needListenerRef.current !== false) {
        handlerRef.current(event);
      }
    };

    if (handlerRef.current) {
      _events.forEach((event) => {
        document.addEventListener(event, listener);
      });
    }

    return () => {
      didCancel = true;
      _events.forEach((eventName) => {
        document.removeEventListener(eventName, listener);
      });
    };
  }, []);
}
